import { InMemoryCache, type TypePolicies } from '@apollo/client';

export function createNewfrontApolloCache(additionalTypePolicies?: TypePolicies): InMemoryCache {
  return new InMemoryCache({
    dataIdFromObject: (object) => {
      if (object.uuid && typeof object.uuid === 'string') return object.uuid;
      if (object.id && typeof object.id === 'string') return object.id;
      return false;
    },
    typePolicies: {
      Query: {
        fields: {
          getChats: {
            keyArgs: ['userUuid', 'accountUuid', 'appType', 'statusFilter', 'deletedOnly'],
          },
        },
      },
      // These responses share UUIDs but have different GraphQL types. Keep them
      // separate so fetching one cannot invalidate fragments on another.
      SkillGroup: { keyFields: ['uuid'] },
      SkillGroupSummary: { keyFields: ['uuid'] },
      SkillAdministrationGroup: { keyFields: ['uuid'] },
      ...additionalTypePolicies,
    },
  });
}
